import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { ThemeContextProvider } from './contexts/ThemeContext';

import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import UploadPage from './pages/UploadPage';
import TemplatePage from './pages/TemplatePage';
import BatteryLoadingPage from './pages/BatteryLoadingPage';
import ResultsPage from './pages/ResultsPage';
import DatenschutzPage from './pages/DatenschutzPage';
import ImpressumPage from './pages/ImpressumPage';
import CookieDemoPage from './pages/CookieDemoPage';
import FeedbackPage from './pages/FeedbackPage';
import GalleryPage from './pages/GalleryPage';
import NotFoundPage from './pages/NotFoundPage';
import CookieBanner from './components/CookieBanner';
import GDPRConsentModal from './components/GDPRConsentModal';
// import { scriptManager } from './utils/ScriptManager';

function App() {
  const [showDetailModal, setShowDetailModal] = useState(false);

  // Script-Manager wird später initialisiert

  const handleOpenDetailModal = () => {
    setShowDetailModal(true);
  };

  const handleCloseDetailModal = () => {
    setShowDetailModal(false);
  };

  return (
    <ThemeContextProvider>
      <Router>
        <AppContent
          showDetailModal={showDetailModal}
          handleOpenDetailModal={handleOpenDetailModal}
          handleCloseDetailModal={handleCloseDetailModal}
        />
      </Router>
    </ThemeContextProvider>
  );
}

function AppContent({
  showDetailModal,
  handleOpenDetailModal,
  handleCloseDetailModal
}: any) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />

      <Box sx={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/vorlagen" element={<TemplatePage />} />
          <Route path="/loading/:uploadId" element={<BatteryLoadingPage />} />
          <Route path="/results/:uploadId" element={<ResultsPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/cookie-demo" element={<CookieDemoPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/galerie" element={<GalleryPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Box>

      <Footer />

      {/* Cookie-Banner - unten links als Overlay */}
      <CookieBanner onOpenDetailModal={handleOpenDetailModal} />

      {/* Detaillierte GDPR-Modal für erweiterte Informationen */}
      <GDPRConsentModal
        open={showDetailModal}
        onClose={handleCloseDetailModal}
        onAccept={() => {
          // Wird über CookieBanner gehandhabt
          handleCloseDetailModal();
        }}
        onDecline={handleCloseDetailModal}
      />
    </div>
  );
}

export default App;